// extracted by mini-css-extract-plugin
module.exports = {"addPost":"index_addPost_2zanB","label":"index_label_2HJPY","submit":"index_submit_GZNBT","editor":"index_editor_1eGPa"};